import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { GALLERY } from "@/lib/site-data";

export const Gallery = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], ["2%", "-62%"]);

  return (
    <section id="gallery" ref={ref} className="relative" style={{ height: "260vh" }}>
      <div className="sticky top-0 flex h-screen flex-col justify-center overflow-hidden">
        <Reveal className="mx-auto mb-10 w-full max-w-[1400px] px-6 lg:px-12">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-avatar-red">
            (Gallery)
          </p>
          <h2 className="font-heading text-4xl font-bold leading-none tracking-tighter text-avatar-ink md:text-6xl">
            Pure. Cool. Safe.
          </h2>
        </Reveal>

        <motion.div style={{ x }} className="flex gap-6 px-6 lg:px-12">
          {GALLERY.map((g, i) => (
            <div
              key={i}
              className="group relative h-[52vh] w-[78vw] shrink-0 overflow-hidden rounded-3xl border border-avatar-ink/10 md:w-[42vw]"
            >
              <img
                src={g.url}
                alt={g.caption}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              <span className="absolute bottom-6 left-6 font-heading text-2xl font-bold tracking-tight text-white">
                {g.caption}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
